import { useState } from 'react';
import { useButtonsStore } from '../../../store/models';

function useEcalWorldSwitch (props) {
    const {
        row,
    } = props;

    const buttonsStore = useButtonsStore();

    const [isPublic, setIsPublic] = useState(row.publicButton === true);
    const [confirmOpen, setConfirmOpen] = useState(false);

    const tooltipTitle = isPublic
        ? 'Discoverable in ECAL World — click to disable'
        : 'Make discoverable in ECAL World';

    const dialogTitle = isPublic ? 'Disable ECAL World' : 'Enable ECAL World';

    const dialogText = isPublic
        ? 'Are you sure you want to turn off this button for ECAL World?'
        : 'Are you sure you want to make this button discoverable in ECAL World?';

    function handleToggle (e) {
        e.stopPropagation();
        e.preventDefault();
        setConfirmOpen(true);
    }

    function handleConfirm () {
        const newValue = !isPublic;
        setIsPublic(newValue);
        buttonsStore.setPublisherButton({
            buttonWidgetId: row.id,
            publicButton: newValue,
        });
        setConfirmOpen(false);
    }

    function handleCancel () {
        setConfirmOpen(false);
    }

    return {
        isPublic,
        confirmOpen,
        tooltipTitle,
        dialogTitle,
        dialogText,
        handleToggle,
        handleConfirm,
        handleCancel,
    };
}

export default useEcalWorldSwitch;
